import "core-js/modules/es.array.map";

var _Separator;

import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Separator, NavLink } from "../../../../../Common";
import { Text } from "../../../../../Typography";
import { Join } from "../../../../../Utils";
import { useTheme } from "../../../../../../theme";
import { ToogleSwitch } from "../../../../../Controls";
import { useHeaderContext } from '../../../HeaderContext';
import ServicesWrapper from './ServicesWrapper';
import TextItem from './TextItem';
import styles from './Navigation.scss';

var Navigation = function Navigation(_ref) {
  var navigation = _ref.navigation,
      onActiveNavLinkClick = _ref.onActiveNavLinkClick;

  var _useHeaderContext = useHeaderContext(),
      isServicesDisabled = _useHeaderContext.isServicesDisabled;

  var _useTheme = useTheme(),
      globalTheme = _useTheme.globalTheme,
      setGlobalTheme = _useTheme.setGlobalTheme,
      isChangeDisabled = _useTheme.isChangeDisabled;

  var _useTranslation = useTranslation('headerUi'),
      t = _useTranslation.t;

  var isNav = !!navigation.length;

  var separator = _Separator || (_Separator = /*#__PURE__*/React.createElement(Separator, {
    marginTop: 0,
    marginBottom: 0
  }));

  var handleToggleGlobalTheme = function handleToggleGlobalTheme() {
    return setGlobalTheme(globalTheme === 'dark' ? 'light' : 'dark');
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, !isChangeDisabled && globalTheme && /*#__PURE__*/React.createElement(React.Fragment, null, separator, /*#__PURE__*/React.createElement(ToogleSwitch, {
    isOn: globalTheme === 'dark',
    onToogle: handleToggleGlobalTheme
  }, /*#__PURE__*/React.createElement(TextItem, null, t('DARK_THEME')))), separator, /*#__PURE__*/React.createElement(Join, {
    separator: separator
  }, navigation.map(function (_ref2) {
    var href = _ref2.href,
        title = _ref2.title;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: href
    }, /*#__PURE__*/React.createElement(NavLink, {
      key: href,
      to: href,
      activeClassName: styles.navLinkActiveText,
      onActiveNavLinkClick: onActiveNavLinkClick
    }, /*#__PURE__*/React.createElement(Container, {
      paddingTop: 1.5,
      paddingBottom: 1.5
    }, /*#__PURE__*/React.createElement(Text, {
      color: "inherit"
    }, title))));
  }), !isServicesDisabled && /*#__PURE__*/React.createElement(ServicesWrapper, {
    isMenu: isNav
  })), separator);
};

export default Navigation;